export const tierIdToPresentationalData = {
  tier1: {
    tierLevel: "Tier 1",
    description: "Guardian Initiate",
  },
  tier2: {
    tierLevel: "Tier 2",
    description: "Guardian Protector",
  },
  tier3: {
    tierLevel: "Tier 3",
    description: "Guardian Defender",
  },
  tier4: {
    tierLevel: "Tier 4",
    description: "Guardian Champion",
  },
  tier5: {
    tierLevel: "Tier 5",
    description: "Guardian Vanguard",
  },
  bonusTier: {
    tierLevel: "Bonus Tier",
    description: "Guardian Infinite",
  },
};
